
<template>
<div id="content" class="no-padding">
    <div class="container"><!-- Container Geral-->
                        <div class="col-md-12">
                            <div class="row">
                                <div class="galeria-div">
                                    <div class="tit-geral">
                                        <h2 class="tit-bloco-princ">Segue Nossa Lista de Serviços</h2>
                                        <hr>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div id="projects-grid" class="projects-boxes" style="    margin: 0 -15px;">
                                        <div class="project-item col-md-3 col-sm-6 business" v-for="dado in dados">
                                                <div class="project-item-inner">
                                                    <a :href="dado.linkservico" target="_blank">
                                                        <img :src="dado.imgservico" alt="" class="img-responsive">
                                                        <div class="project-details"></div>
                                                    </a>
                                                </div>
                                                <h3 class="post-title">
                                                    <a rel="bookmark" target="_blank" :href="dado.linkservico">{{dado.tituloservico}}</a>
                                                </h3>
                                                <div class="post-content">

                                                    <p>{{dado.resumoservico}}</p> 

                                                    <div class="latest-blog-post-data">
                                                        <a class="btn btn-border" target="_blank" :href="dado.linkservico">Solicitar</a>
                                                        <a v-if="dado.modalperguntas != ''" href="#" data-toggle="modal" :data-target="dado.maisservico"><span class="fa fa-plus mais-info" aria-hidden="true" title="Mais Informações"></span></a>
                                                    </div>

                                                </div><!-- .post-content -->
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div><!-- Fim Conteiner Geral-->
                </div>

                <!--
                modais entram aqui em baixo
                -->
                <cpmodal v-for="dado in dados" :line="dado"></cpmodal>
                
</div>
</template>
<script>
    
    import Cpmodal from './modal.vue'

    export default{
        data(){
            return{
                dados:{}
            }
        },
        components:{
            Cpmodal
        },
        ready(){
            
            $.ajaxSetup({
                async: false
            });
            var self = this;
            //json com os dados do header
            $.getJSON('./../server/servicos.php', function(dados)
            {                
                self.dados = dados;
                //console.log(self.dados)
            });

            $.ajaxSetup({
                async: true
            });

            //hover dos serviços
            $('.project-item').hover(function () {
                $(this).find('.project-details').stop(true, true).fadeIn().find('.folio-title').stop(true, true).animate({'top': 20}).end().find('.folio-cate').stop(true, true).animate({'bottom': 20});
            }, function () {
                $(this).find('.project-details').stop(true, true).fadeOut().find('.folio-title').stop(true, true).animate({'top': -20}).end().find('.folio-cate').stop(true, true).animate({'bottom': -20});
            });
            //hover dos serviços

        }
    }

</script>



// WEBPACK FOOTER //
// conteudo.vue?394da8a6